import clsx from 'clsx';
import type { ComponentPropsWithoutRef, ComponentRef } from 'react';
import { forwardRef } from 'react';

import { CheckIcon } from '~components/icons/CheckIcon';
import { Button } from '~modules/media-library/view/Button';

export const SortMenuItemButton = forwardRef<
  ComponentRef<typeof Button>,
  Omit<ComponentPropsWithoutRef<typeof Button>, 'variant'> & { focus?: boolean; selected?: boolean }
>(function SortMenuItemButton({ children, focus = false, selected = false, className = '', ...ButtonProps }, ref) {
  return (
    <Button
      variant="ghost"
      className={clsx('ml--sort-menu--item', selected && 'font-semibold', focus && 'underline', className)}
      {...ButtonProps}
      ref={ref}
    >
      <CheckIcon className={clsx('mr-2 w-4 h-4 transition', selected ? 'opacity-100' : 'opacity-0')} />
      <span className="flex-grow">{children as React.ReactNode}</span>
    </Button>
  );
});
